<!-- <div [class.loader-hidden]="false"> -->
@if (show) {
  <div class="mainSpinner">
    <div class="loader-overlay">
      <div>
        @if (true) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </div>
    </div>
  </div>
}
